/*
 * @file: user.js
 * @description: Reducers and actions for store/manipulate user's  data
 * @date: 28.11.2019
 * @author: Anil
 */

/******** Reducers ********/

const initialState = {
  loggedIn: false,
  notifications: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return { ...state, ...{ loggedIn: true }, ...action.data, supplier_id: action.data?.supplier_id?.id || action.data?.supplier_id?.id ? { ...action.data.supplier_id, id: action.data.supplier_id?.id || action.data.supplier_id?._id } : null };
    case 'LOG_OUT':
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      return initialState;

    default:
      const token =
        typeof window !== 'undefined'
          ? localStorage.getItem('token') || sessionStorage.getItem('token')
          : null;
      if (token) {
        return state;
      } else {
        return initialState;
      }
  }
}
